( function( $ ) {
	function destroyInfinitySlider( $container ) {
		$container.find( '.infiniteslide_clone' ).remove();
		$container.find( '.infinity-slide' ).removeAttr( 'style' );
		$container.find( '.js-simple-slider-infiniteslide' ).removeAttr( 'style' ).removeAttr( 'data-style' );
		$container.find( '.section-simple-slider__slider' ).addClass( 'active-paddings' );
	}

	function getCloneCount( $container ) {
		const $slide = $container.find( '.infinity-slide' );
		const slideWidth = $slide.outerWidth();
		const sliderWidth = $container.outerWidth();
		const numberOfSlides = $slide.length;
		const requiredNumberOfSlides = Math.ceil( sliderWidth / slideWidth ) * 2;
		const result = Math.ceil( requiredNumberOfSlides / numberOfSlides ) - 1;

		return result < 1 ? 1 : result;
	}

	function initInfinitySlider( section ) {
		const $infiniteslider = $( section ).find( '.js-simple-slider-infiniteslide' );

		$infiniteslider.each( function() {
			
			const $container = $( this );
			
			const sliderCall = () => {
				$( section ).find( '.section-simple-slider__slider' ).removeClass( 'active-paddings' );

				const loadInfiniteslide = () => {
					$container.infiniteslide( {
						'speed': 50, //speed this is px/min
						'direction': 'left', //choose  up/down/left/right
						'pauseonhover': true, //if true,stop onmouseover
						'responsive': false, //width/height recalculation on window resize. child element's width/height define %/vw/vh,this set true.
						'clone': getCloneCount( $container ) //if child elements are too few (elements can't "infinite"), set 2 or over.
					} );
				};
				window.app.loadVendor( 'Infiniteslide', loadInfiniteslide );
			};

			if ( $container.outerWidth() <= $container.find( '.infinity-slide' ).length * $container.find( '.infinity-slide:first-child' ).outerWidth() ) {
				sliderCall();
			}  					
		} );
	}

	let initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-simple-slider' );

		destroyInfinitySlider( $section );
		initInfinitySlider( $section );
	};

	window.app.loadBlock( initBlock, 'section-simple-slider', '.section-simple-slider' );
} )( jQuery );